import CalorieRange from './CalorieRange';

export default CalorieRange;
